export const RECIPES_DIFFICULTY_OPTIONS = [
    { value: 1, label: 'Super Easy' },
    { value: 2, label: 'Easy' },
    { value: 3, label: 'Medium' },
    { value: 4, label: 'Hard' },
    { value: 5, label: 'Super Hard' },
];